<template>
	<div>
		<p> Arbeitsgruppen bestehen aus Personen, die Sie im Bereich 'Mitarbeiter' anlegen. Arbeitsgruppen stehen Ihnen beim Bearbeiten der Erhebung zur Verfügung, um schnell Zusammenarbeitsvorgänge zu bestimmten Themen zu erstellen.
		</p>
	</div>
</template>

<style lang="less">
	
</style>

<script type="text/javascript">
	export default {
		name: "AboutGroups", 
		props: {
			
		},
		data: () => {
			return {

			}
		},
	}
</script>